<template>
  <div id="A0" class="sub">
    <div class="wrapper">
      <kg-header :headerType=1 />
      <div class="inner_static">
        <h1 class="tit1">NEWS一覧</h1>
      </div>
      <kg-news-list
        :upperLimit="dispNewsCount"
        ref="ddNewsList"/>
      <div class="btn_area">
        <a class="btn_more2" @click="btnNewsMoreClick()">More</a>
      </div>
    </div>
  </div>
</template>

<script>
// kaggul Module
import Header from '../components/common/HomeIconHeader'
import NewsList from '../components/top/NewsList'

export default {
  components: {
    'kg-header': Header,
    'kg-news-list': NewsList
  },
  data () {
    return {
      dispNewsCount: 7
    }
  },
  methods: {
    btnNewsMoreClick: function () {
      if (this.$refs.ddNewsList.newsListLength() > this.dispNewsCount) {
        this.dispNewsCount += 3
      }
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/News.vue